import classNames from 'classnames';
import React from 'react';

export default function GenericCarouselWrapper({
  className,
  children,
}: {
  children?: React.ReactNode;
  className?: string;
}) {
  return <div className={classNames('', className)}>{children}</div>;
}
